"use strict";

/**
 * This checks if the object (or array) is empty.
 * Empty is defined in this context by not having any value or properties defined.
 * @param {object} obj
 * @returns {boolean}
 */
function isNullOrEmpty(obj) {
  return (
    !obj ||
    (Array.isArray(obj) && !obj.length) ||
    Object.entries(obj).length === 0
  );
}

/**
 * This is an alternative to the Lodash get function. It uses the object passed
 * and parses to the location in the keys specified to get the value, or defaults
 * to the defaultVal specified
 * @param {object} obj
 * @param {string | array} keys
 * @param {*} defaultVal
 * @returns {*}
 */
function getProp(obj, keys, defaultVal = undefined) {
  keys = Array.isArray(keys) ? keys : keys.split(".");
  obj = obj[keys[0]];
  if (obj && keys.length > 1) {
    return getProp(obj, keys.slice(1), defaultVal);
  }
  return obj === undefined ? defaultVal : obj;
}

module.exports = {
  isNullOrEmpty,
  getProp
};
